class NSSAccordionGroup extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.els = {
      items: this.querySelectorAll(`.nss-accordion-item`),
    }
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Accordion Group] Connected.`);

    this.addEventListener(`click`, this.handleClick.bind(this));
    this.initImageButtons();
  }

  initImageButtons() {
    const section = this.closest(`.shopify-section`);
    if (!section) return;

    const slots = [...section.querySelectorAll(`.js-accordion-image`)];
    if (!slots.length) return;

    // Count only items that have an image
    const itemsWithImages = [...this.els.items].filter(item => item.querySelector(`img`));
    const total = itemsWithImages.length;

    slots.forEach(slot => {


      itemsWithImages.forEach((item, index) => {
        const img = item.querySelector(`img`);

        const btn = document.createElement(`button`);
        btn.type = `button`;
        btn.dataset.accordionIndex = [...this.els.items].indexOf(item);
        btn.appendChild(img.cloneNode(true));

        // Position around the circle
        // Angle starts at 12 o'clock (-90°) and goes clockwise
        const angle = (2 * Math.PI / total * index) - (Math.PI / 2);
        const x = 50 + 50 * Math.cos(angle);
        const y = 50 + 50 * Math.sin(angle);

        btn.style.position  = `absolute`;
        btn.style.left      = `${x}%`;
        btn.style.top       = `${y}%`;
        btn.style.transform = `translate(-50%, -50%)`;

        btn.addEventListener(`click`, () => {
          const accordionIndex = parseInt(btn.dataset.accordionIndex);
          const linkedItem = this.els.items[accordionIndex];
          if (linkedItem.classList.contains(`nss-active`)) {
            this.closeAllItems();
            this.setActiveImageButton(-1);
          } else {
            this.closeAllItems();
            linkedItem.classList.add(`nss-active`);
            this.setActiveImageButton(accordionIndex);
          }
        });

        slot.appendChild(btn);
      });
    });

    // Reflect initially active item across all slots
    const activeIndex = [...this.els.items].findIndex(item =>
      item.classList.contains(`nss-active`)
    );
    this.setActiveImageButton(activeIndex);
  }

  setActiveImageButton(activeIndex) {
    const section = this.closest(`.shopify-section`);
    if (!section) return;

    section.querySelectorAll(`.js-accordion-image button[data-accordion-index]`).forEach(btn => {
      btn.classList.toggle(`nss-active`, parseInt(btn.dataset.accordionIndex) === activeIndex);
    });
  }

  handleClick(e) {
    const item = e.target.closest(`.nss-accordion-item`);
    if (!item) return;

    const index = [...this.els.items].indexOf(item);

    if (item.classList.contains(`nss-active`)) {
      this.closeAllItems();
      this.setActiveImageButton(-1);
    } else {
      this.closeAllItems();
      item.classList.add(`nss-active`);
      this.setActiveImageButton(index);
    }
  }

  closeAllItems() {
    this.els.items.forEach(itemEl => {
      itemEl.classList.remove(`nss-active`);
    });
  }
}

let elementName = `nss-accordion-group`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSAccordionGroup);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}
